module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/cq04.ce47e96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone/blog/cq04.jpg
// module id = ZKzl
// module chunks = 0